// Cell.tsx
import React, { useState } from 'react';
import './App.css';

interface CellProps {
    x: string;
    y: string;
}
  
const Cell: React.FC<CellProps> = ({x,y}) => {
  const [color, setColor] = useState<'green' | 'darkred' | 'grey'>('grey');

  const handleClick = () => {
    setColor(prevColor => prevColor === 'green' ? 'darkred' : prevColor === 'darkred' ? 'grey' : 'green');
  };

  return (
    <div className='cell'><button onClick={handleClick} style={{ backgroundColor: color }}>{x}{y}</button></div>
  );
}

export default Cell;